// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ch-a";
export var fulfillmentFormRail = "_ch-9";
export var headerTitleRow = "_ch-c";
export var orderDetailsWrapper = "_ch-7";
export var orderLinkTrigger = "_ch-2";
export var paymentInformationGrid = "_ch-h";
export var paymentSummaryColumn = "_ch-i";
export var shipmentContainer = "_ch-b";
export var shipmentDetailsMainPane = "_ch-8";
export var shipmentNavigationCard = "_ch-5";
export var shipmentNavigationRail = "_ch-3";
export var shipmentNavigationRailHeader = "_ch-4";
export var shipmentSummaryFact = "_ch-e";
export var shipmentSummaryGrid = "_ch-d";
export var shipmentSummaryMetadataRow = "_ch-f";
export var shipmentSummaryTags = "_ch-g";
export var shipmentWorkspace = "_ch-0";
export var shipmentWorkspaceContent = "_ch-6";
export var shipmentWorkspaceHeader = "_ch-1";